import React from 'react';

export const KofiIcon: React.FC<{ className?: string }> = ({ className = 'w-5 h-5' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.164 2.424 2.586 2.672 2.586 2.672s8.267-.023 11.966-.049c2.438-.426 2.683-2.566 2.683-2.566l.044-2.593s3.136.236 4.908-1.508c1.773-1.743 1.672-4.478 1.672-4.478zm-6.284 3.731l-.096 1.258s-.175 1.139-1.213 1.139c-1.038 0-11.455.044-11.455.044s-1.127-.044-1.213-1.139c-.088-1.094-.044-8.084-.044-8.084h13.929l.092 6.782zm3.325-1.182c-.658.744-1.776.657-1.776.657V6.521s1.353-.131 2.053.481c.7.613.821 1.777.348 2.766-.473.988-.625 1.464-.625 1.464z" />
    <path d="M11.66 8.357c-1.562-1.921-4.066-.312-4.066 1.344 0 1.938 3.86 4.609 4.066 4.75.206-.141 4.066-2.812 4.066-4.75 0-1.656-2.504-3.265-4.066-1.344z" fill="#FF5E5B" />
  </svg>
);

export const SociabuzzIcon: React.FC<{ className?: string }> = ({ className = 'w-5 h-5' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2C6.477 2 2 6.477 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.523-4.477-10-10-10zm1.2 14.8h-2.4l.8-4.8H9.2l3.6-6.4h2.4l-.8 4.8h2.4l-3.6 6.4z" />
  </svg>
);
